import { CLIMBING_STYLES } from '../constants.js';
import { SPORT_CLEAN_ASCENT_TYPES, BOULDER_CLEAN_ASCENT_TYPES } from '../gradeUtils.js';

export const calculateCGP = (ascents, climbingStyle) => {
  if (!ascents?.length) return 0;

  const cleanAscents = ascents.filter(ascent => {
    const isCleanAscent = climbingStyle === CLIMBING_STYLES.BOULDER ? 
      BOULDER_CLEAN_ASCENT_TYPES.includes(ascent["Ascent Type"]) :
      SPORT_CLEAN_ASCENT_TYPES.includes(ascent["Ascent Type"]);
    
    return isCleanAscent && ascent.isClean;
  });

  if (!cleanAscents.length) return 0;

  if (climbingStyle === CLIMBING_STYLES.BOULDER) {
    const sum = cleanAscents.reduce((acc, ascent) => {
      if (ascent.vgrade === null || isNaN(ascent.vgrade)) return acc;
      return acc + Math.exp(ascent.vgrade);
    }, 0);
    return Math.log(sum); // Remove toFixed
  } else {
    const sum = cleanAscents.reduce((acc, ascent) => {
      if (ascent.ewbanks === null || isNaN(ascent.ewbanks)) return acc;
      return acc + Math.pow(2, ascent.ewbanks);
    }, 0);
    return Math.log2(sum); // Remove toFixed
  }
};

export const calculateCGE = (ascents, climbingStyle) => {
  if (!ascents?.length) return 0;

  // For CGE, we include all ascents with valid grades, not just clean ones
  const validAscents = ascents.filter(ascent => {
    if (climbingStyle === CLIMBING_STYLES.BOULDER) {
      return ascent.vgrade !== null && !isNaN(ascent.vgrade);
    } else {
      return ascent.ewbanks !== null && !isNaN(ascent.ewbanks);
    }
  });

  if (!validAscents.length) return 0;

  if (climbingStyle === CLIMBING_STYLES.BOULDER) {
    const sum = validAscents.reduce((acc, ascent) => {
      return acc + Math.exp(ascent.vgrade);
    }, 0);
    return Math.log(sum);
  } else {
    const sum = validAscents.reduce((acc, ascent) => {
      return acc + Math.pow(2, ascent.ewbanks);
    }, 0);
    return Math.log2(sum);
  }
};